const SocialMediaConstants = {
    LEFT: 'left',
    RIGHT: 'right',
}

export default SocialMediaConstants
